import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from 'react-oidc-context';
import { WebStorageStateStore } from 'oidc-client-ts';
import { clearAuthCallbackRetry } from './components/auth/AuthCallback';
import * as Sentry from "@sentry/react";

const serverIntegrations = [];

if (process.env.NODE_ENV === "production" || process.env.NODE_ENV === "staging") {
  serverIntegrations.push(
    Sentry.browserTracingIntegration(),
  );
}

if (process.env.NODE_ENV === "production") {
  serverIntegrations.push(
    Sentry.replayIntegration({
      maskAllText: false,
    })
  );
}

Sentry.init({
  dsn: "https://bb8bb9b0d18d52750c6fa6d45e5bd373@o4509823577948160.ingest.us.sentry.io/4509823578734592",
  sendDefaultPii: true,
  integrations: [
    ...serverIntegrations,
  ],
  tracesSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,
  tracePropagationTargets: [
    /^\//,
    /^https:\/\/([a-z0-9-]+\.)*dentaris\.mx/,
    /^https:\/\/([a-z0-9-]+\.)*digitaport\.com/,
  ],
  environment: process.env.NODE_ENV,
});

const cognitoAuthConfig = {
  authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_TOhvlUrxq",
  client_id: "2furhq1s6v5mbj77uafsr7j660",
  redirect_uri: `${process.env.REACT_APP_BASE_DOMAIN || window.location.origin}/cb`,
  response_type: "code",
  scope: "phone openid email",
  automaticSilentRenew: true,
  extraQueryParams: { lang: "es" }, // Pass language as query param
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  onSigninCallback: () => {
    clearAuthCallbackRetry();
    window.history.replaceState({}, document.title, "/");
  }
};

const root = ReactDOM.createRoot(document.getElementById("root"));

// wrap the application with AuthProvider
root.render(
  <React.StrictMode>
    <AuthProvider {...cognitoAuthConfig}>
      <App />
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
